import React, { useState } from 'react';
import {
  Typography,
  makeStyles,
  Box,
  Theme,
  Grid,
  Button,
} from '@material-ui/core';
import { colors } from '../../../theme';
import MessageBox from '../MessageBox';
import InstructionsLayout from '../../Composite/InstructionsLayout';
import { imgInfraSeguro } from '../../../svg';

const useStyles = makeStyles((theme: Theme) => ({
  images: {
    alignSelf: 'center',
  },
  underInsuranceText: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '1.375rem',
    textAlign: 'justify',
    color: '#555659',
  },
  underInsuranceBox: {
    paddingTop: '8px',
    paddingRight: '18PX',
    paddingLeft: '18px',
    paddingBottom: '8px',
  },
  linkInTextStyle: {
    padding: 0,
    color: `${colors.bright_turquoise}`,
    fontWeight: 'bold',
    fontSize: '14px',
    textTransform: 'none',
    '&:hover, &:focus': {
      backgroundColor: 'rgba(255,255,255,0)',
    },
  },
  textUnderInsurance: {
    [theme.breakpoints.down('md')]: {
      weight: '15.5625rem',
      fontWeight: 'bold',
    },
    [theme.breakpoints.up('md')]: {
      fontWeight: 700,
      weight: '31.6875rem',
    },
    fontSize: '13px',
    lineHeight: '18px',
  },
}));

type Props = {
  projectName: string;
  showMessageUnInsured: boolean;
};

const UnderinsuranceHelp = ({
  projectName,
  showMessageUnInsured,
}: Props): JSX.Element => {
  const [isOpenUnInsuredModal, modalUnInsuredIsOpen] = useState(false);
  const classes = useStyles();
  return (
    showMessageUnInsured && (
      <>
        <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
          <MessageBox
            message={
              <Typography className={classes.textUnderInsurance}>
                Observación: El monto ingresado es inferior al valor promedio de
                este auto.
                <Button
                  className={classes.linkInTextStyle}
                  id={projectName.concat('-button-un-insuredvaluehelp')}
                  onClick={(): void =>
                    modalUnInsuredIsOpen(!isOpenUnInsuredModal)
                  }
                >
                  VER MAS
                </Button>
              </Typography>
            }
            variant="info"
            hideCloseButton
          />
        </Grid>
        <InstructionsLayout
          id={projectName.concat('-modal-under-insuredvaluehelp')}
          open={isOpenUnInsuredModal}
          headerTitle="¡Asegura tu auto por su valor real!"
          title={
            <>
              <img
                src={imgInfraSeguro.toString()}
                alt="infra seguro"
                className={classes.images}
              />
            </>
          }
          content={
            <Box className={classes.underInsuranceBox}>
              <Typography className={classes.underInsuranceText} paragraph>
                Si aseguras tu auto por un valor inferior al que realmente
                tiene, al presentar un reclamo, la aseguradora pagará en
                proporción a dicho valor.
              </Typography>
              <Typography className={classes.underInsuranceText} paragraph>
                En ese caso es muy probable que el monto pagado no sea
                suficiente para cubrir tus daños y/o pérdidas; según los costos
                del mercado.
              </Typography>
            </Box>
          }
          instructions=""
          onCloseRequested={(): void => modalUnInsuredIsOpen(false)}
        />
      </>
    )
  );
};

export default UnderinsuranceHelp;
